import {
  assertEvent,
  assign,
  fromPromise,
  setup,
  type SnapshotFrom,
} from 'xstate';

import type {
  IRsvpMachineContext,
  IRsvpMachineEvents,
  IRsvpMachineInput,
} from '../../machines/rsvpMachine/rsvpMachine.types';
import {
  rsvpUpdateStatus,
  saveToCalender,
} from '../../services/schedularService';
import type {IRsvpStatus} from '../../types/IRsvpStatus';
import {downloadFile} from '../../utils/common';


export const rsvpMachine = setup({
  types: {
    context: {} as IRsvpMachineContext,
    events: {} as IRsvpMachineEvents,
    input: {} as IRsvpMachineInput,
  },
  actors: {
    handleRsvp: fromPromise(
      async ({
        input,
      }: {
        input: {eventId: string; aid: string; rsvpStatus: IRsvpStatus};
      }) => {
        await rsvpUpdateStatus(input.eventId, input.aid, {
          status: input.rsvpStatus,
        });
        return input.rsvpStatus;
      },
    ),
    handleSaveToCalender: fromPromise(
      async ({input}: {input: {eventId: string}}) => {
        const response = await saveToCalender(input.eventId);
        downloadFile(response.data, 'event.ics');
      },
    ),
  },
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QCdYDcAOA6AlgOxwBcBiVTLAYwAsBDPGAbQAYBdRUDAe1iJ073YgAHogC0AZgCMWACzim4gEwBOFQHYAbJKYBWADQgAnmMWKsy8VoAcGpsotqrOtTIC+rg2Wz4ixWDTQwABVOAGEaABswPAgwZGY2JBAuHkI+ASSRBHE1JiwmK2U1RUkZHTKdJzUDYwRRU3NLSRs7Byqrd090bC8AGU4aCHwoYgh+MFw8NE4AawmvLD6BofoEfGmKGjT+BITBFN5+QSz6nXFZDUucy5kyjRlqozFmnXz5NUrVEp1JNXFOkALJaDYbEOLITjILAYCJbABmkIAtotuijMP0Qat1pxNts8LtWPtuIcMqATvJpJYdExHL81MoCuIZDVEJJFGosIoymUPjoNIVVACFv5AuEojE4hiViMxngJti5mjsCKwGLorFkFLhmspjitukCYkOMS8cdEH9XlY2ZJ+ZYXLZxCyEGyOVzyuyND9qXyOh5AaiVWqJZrlqDwZDobDCAjkMjhQFVZF1ZLQ1jdbiDaw9kkDqbMubLLIrDImGUmZdFJYnaJJHysJILFafbcZFV3H68JxYvAkl4ial0ma6kzlFgqTSrWp6YzmU86uyzGcaSXlBo7UydELUT5CP2SUOG1Yx85lGyuX8rCpqw0LBp1M5mgU7Got+RgdK93mySYnPlVypJEAukmAUasZA0WRLC5NclH5FR-j9eNRSTYMtXoT9B3zBBijMFRPRyXkmGtMCILkO9wPEWDLwsdtXCAA */
  context: ({input: {eventId, aid, rsvpStatus}}) => ({
    eventId,
    aid,
    rsvpStatus,
  }),

  id: 'rsvp',
  initial: 'init',

  states: {
    init: {
      on: {
        'rsvp.change': {
          target: 'rsvpLoading',
          actions: assign({
            error: undefined,
          }),
        },
        saveToCalender: {
          target: 'saveCalenderLoading',
          actions: assign({
            error: undefined,
          }),
        },
      },
    },
    rsvpLoading: {
      invoke: {
        input: ({context, event}) => {
          assertEvent(event, 'rsvp.change');
          return {
            eventId: context.eventId,
            aid: context.aid,
            rsvpStatus: event.status,
          };
        },
        onDone: {
          target: 'init',
          actions: assign({
            rsvpStatus: ({event}) => event.output,
          }),
        },
        onError: {
          target: 'init',
          actions: assign({
            error: ({event}) => event.error,
          }),
        },
        src: 'handleRsvp',
      },
    },
    saveCalenderLoading: {
      invoke: {
        input: ({context, event}) => {
          assertEvent(event, 'saveToCalender');
          return {
            eventId: context.eventId,
          };
        },
        onDone: {
          target: 'init',
        },
        onError: {
          target: 'init',
          actions: assign({
            error: ({event}) => event.error,
          }),
        },
        src: 'handleSaveToCalender',
      },
    },
  },
});

export type IRsvpMachineSnapshot = SnapshotFrom<typeof rsvpMachine>;
